import React, { Fragment, useState, useEffect } from "react";
import Topbar from "../layouts/TopBar";
import Footer from "../layouts/Footer";
import EventResources from "../resources/EventResources";
import UserResources from "../resources/UserResources";
import RotaResources from "../resources/RotaResources";
import RotaRoleResources from "../resources/RotaRoleResources";
import toast from 'react-hot-toast';
import moment from "moment/moment";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { connect } from "react-redux";
import { logout } from "../redux/actions/LoggedInAction";
import DateTime from 'react-datetime';

function EventDetailsAdmin({isLoggedIn, loggedInUser}){
    const location = useLocation();
    const navigate = useNavigate();

    const [mediaStartTime, setMediaStartTime] = useState(null);
    const [editEventDate, setEditEventDate] = useState('');
    const [editStartTime, setEditStartTime] = useState(null);
    const [editEndTime, setEditEndTime] = useState(null);
    const [events, setEvents] = useState([])
    const [eventId, setEventId] = useState('')
    const [eventVolunteers, setEventVolunteers] = useState([])
    const [users, setUsers] = useState([])
    const [selectedOption, setSelectedOption] = useState({}); // stores the entire user details
    const [availabiltyInfo, setavailabiltyInfo] = useState('');
    const [isRotaPublished, setIsRotaPublished] = useState(false)
    const [rotaRoles, setRotaRoles] = useState([])
    const [selectedRoles, setSelectedRoles] = useState([])
    const [closeUpMapping, setCloseUpMapping] = useState([])
    const [roamingMapping, setRoamingMapping] = useState([])
    const [isGenerating, setIsGenerating] = useState(false)
    const resources = new EventResources()
    const rotaResources = new RotaResources()
    const rotaRoleResources = new RotaRoleResources()
  
    // Function to handle dropdown change
    const handleDropdownChange = (event) => {
      setSelectedOption(event.value);
    };

    const handleTimeChange = (value) => {
        setMediaStartTime(value);
    };
  
    // Function to handle textbox change
    const handleAvailabilityInputChange = (event) => {
        setavailabiltyInfo(event.target.value);
                           
    };

    const handleUpdateMediaSetupTime = () => {
        if (!mediaStartTime || !mediaStartTime.isValid()) {
            toast.error("Please select a time");
            return;
        }
        const newTimeString = mediaStartTime.format('HH:mm:ss');

         // Combine the existing date part with the new time part
        let currentMediaSetupTime = events[0]['media_setup_time']
        const updatedMediaDateString = moment(currentMediaSetupTime).format('YYYY-MM-DD') + ' ' + newTimeString
        const updatedMediaDateTime = moment( updatedMediaDateString ).format('YYYY-MM-DD HH:mm:ss');
        let formData = {}
        formData['user_email'] = loggedInUser['email']
        formData['id'] = events[0]['id']
        formData['media_setup_time'] = updatedMediaDateTime

        resources.admin_put(formData).then(res => {
            if (res.error.length < 1) {
                toast.success("Setup Time Updated successfully")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/eventdetailsadmin?id='+events[0]['id'];
                  }, 200);
            }else if(res.error === 'You do not have permission to make this change') {
                toast.error("You do not have permission to make this change.")
            }
             else {
                //toast.error("Operation Failed: " + res.error);
                toast.error("An Issue occured, please retry")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });

    };

    const handleUpdateEventDateTime = () => {
        if (!editEventDate) {
            toast.error("Please select an event date.");
            return;
        }
        if (!editStartTime || !editStartTime.isValid()) {
            toast.error("Please select a valid start time.");
            return;
        }
        if (!editEndTime || !editEndTime.isValid()) {
            toast.error("Please select a valid end time.");
            return;
        }
        const combinedStart = moment(editEventDate + ' ' + editStartTime.format('HH:mm:ss'));
        const combinedEnd = moment(editEventDate + ' ' + editEndTime.format('HH:mm:ss'));
        if (!combinedEnd.isAfter(combinedStart)) {
            toast.error("End time must be after start time.");
            return;
        }
        let formData = {};
        formData['user_email'] = loggedInUser['email'];
        formData['id'] = events[0]['id'];
        formData['event_date'] = moment(editEventDate).format('YYYY-MM-DD HH:mm:ss');
        formData['start_time'] = combinedStart.format('YYYY-MM-DD HH:mm:ss');
        formData['end_time'] = combinedEnd.format('YYYY-MM-DD HH:mm:ss');
        formData['media_setup_time'] = combinedStart.clone().subtract(90, 'minutes').format('YYYY-MM-DD HH:mm:ss');

        resources.admin_put(formData).then(res => {
            if (res.error.length < 1) {
                toast.success("Event date and times updated successfully");
                setTimeout(() => {
                    window.location.href = window.location.origin + '/eventdetailsadmin?id=' + events[0]['id'];
                }, 200);
            } else if (res.error === 'You do not have permission to make this change') {
                toast.error("You do not have permission to make this change.");
            } else {
                toast.error("An issue occurred, please retry");
            }
        }).catch((err) => {
            toast.error("Network Error: " + err);
        });
    };

    const handleRotaGeneration = () => {
        if (events.length === 0) {
            toast.error("Event data not loaded");
            return;
        }

        // Validate role mapping if roles are selected
        if (selectedRoles && selectedRoles.length > 0) {
            if (closeUpMapping.length === 0 && roamingMapping.length === 0) {
                toast.error("Please map at least one core role (Close Up Camera or Roaming Camera)")
                return
            }
        }

        const confirmed = window.confirm("Generate Rota For this Event?");
        if (!confirmed) {
            return;
        }

        // Build role_mappings
        let roleMappings = null
        if (selectedRoles && selectedRoles.length > 0 && (closeUpMapping.length > 0 || roamingMapping.length > 0)) {
            roleMappings = {}
            closeUpMapping.forEach(r => { roleMappings[r.value] = "Close_Up_Camera" })
            roamingMapping.forEach(r => { roleMappings[r.value] = "Roaming_Camera" })
        }

        const event = events[0];
        const rotaData = {
            event_id: event['id'],
            monthly_generation: false,
            requested_roles: selectedRoles && selectedRoles.length > 0 ? selectedRoles.map(r => r.value) : [],
            role_mappings: roleMappings
        };

        setIsGenerating(true)
        rotaResources.create_event_rota(rotaData).then(response => {
            setIsGenerating(false)
            if (response.error && response.error.length > 0) {
                toast.error("Failed to generate rota: " + response.error)
            } else {
                toast.success("Rota generated successfully");
                checkRotaPublishedStatus();
                navigate('/managerota')
            }
        }).catch((err) => {
            setIsGenerating(false)
            toast.error("Failed to generate rota: " + err);
        });
    };

    const checkRotaPublishedStatus = () => {
        if (events.length === 0) return;

        const eventDate = moment(events[0]['event_date']).format('DD-MM-YYYY HH:mm:ss');
        rotaResources.get_rota_detail(eventDate).then(response => {
            const rotaData = response['body'];
            setIsRotaPublished(rotaData['enabled'] || false);
        }).catch((err) => {
            setIsRotaPublished(false);
        });
    };

    // Function to handle button clicks
    const handleApproveEventButtonClick = (ev) => { 
        resources.admin_approve_event_post(ev).then(res => {
            if (res.error.length < 1) {
                toast.success("Event Approved")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/manageevents';
                  }, 200);
            }
            else {
                toast.error("Approval Failed.")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });
      };

      // Function to handle button clicks
      const handleRefuseEventButtonClick = (ev) => {      
        resources.admin_refuse_event_post(ev).then(res => {
            if (res.error.length < 1) {
                toast("Event Refused. Speak to Seyi to Completely remove if needed")
                setTimeout(() => {
                    window.location.href = window.location.origin + '/manageevents';
                  }, 200);
            }
            else {
                toast.error("Approval Process Failed.")
            }
            }).catch((err) => {
                toast.error("Network Error: " + err);
            });


      };
  
    // Function to handle button clicks
    const handleAddVolunteerButtonClick = () => {      
              
      if(Object.keys(selectedOption).length === 0)
      {
        toast.error("Please Select A Name")
        return;
      }
      let volunteer = {};
      volunteer['user_id'] = Number(selectedOption['id'])
      if(availabiltyInfo.length > 1 )
      {
        volunteer['availabilty_info'] = availabiltyInfo
      }
      volunteer['event_id'] = Number(eventId)
      resources.post_Volunteers(volunteer).then(res => {
          if (res.error.length < 1) {
              toast.success("Volunteer added successfully")
              setTimeout(() => {
                  window.location.href = window.location.origin + '/eventdetailsadmin?id='+eventId;
              }, 200);
          } else {
              toast.error("Failed to add volunteer: " + res.error)
          }
      }).catch((err) => {
          toast.error("Network Error: " + err);
      });
    };

    // Function to handle button clicks
    const handleDeleteVolunteerButtonClick = () => {
      if(Object.keys(selectedOption).length === 0)
      {
        toast.error("Please Select your Name")
        return;
      }
      let volunteer = {};
      volunteer['user_id'] = Number(selectedOption['id'])
      volunteer['event_id'] = Number(eventId)
      resources.delete_Volunteer(volunteer).then(res => {
          if (res.error.length < 1) {
              toast.success("Volunteer removed successfully")
              setTimeout(() => {
                  window.location.href = window.location.origin + '/eventdetailsadmin?id='+eventId;
              }, 200);
          } else {
              toast.error("Failed to remove volunteer: ")
          }
      }).catch((err) => {
          toast.error("Network Error: " + err);
      });
    };

    // Function to handle closing event
    const handleCloseEventButtonClick = () => {
        if (events.length === 0) {
            toast.error("Event data not loaded");
            return;
        }

        const confirmed = window.confirm("Close this event? No more volunteers will be able to sign up.");
        if (!confirmed) {
            return;
        }

        let formData = {};
        formData['user_email'] = loggedInUser['email'];
        formData['id'] = events[0]['id'];
        formData['event_closed'] = true;

        resources.admin_put(formData).then(res => {
            if (res.error.length < 1) {
                toast.success("Event closed successfully");
                setTimeout(() => {
                    window.location.href = window.location.origin + '/eventdetailsadmin?id='+events[0]['id'];
                }, 200);
            } else if(res.error === 'You do not have permission to make this change') {
                toast.error("You do not have permission to make this change.");
            } else {
                toast.error("An Issue occured, please retry");
            }
        }).catch((err) => {
            toast.error("Network Error: " + err);
        });
    };

    // Function to handle opening event
    const handleOpenEventButtonClick = () => {
        if (events.length === 0) {
            toast.error("Event data not loaded");
            return;
        }

        const confirmed = window.confirm("Open this event? Volunteers will be able to sign up again.");
        if (!confirmed) {
            return;
        }

        let formData = {};
        formData['user_email'] = loggedInUser['email'];
        formData['id'] = events[0]['id'];
        formData['event_closed'] = false;

        resources.admin_put(formData).then(res => {

            if (res.error.length < 1) {
                toast.success("Event opened successfully");
                setTimeout(() => {
                    window.location.href = window.location.origin + '/eventdetailsadmin?id='+events[0]['id'];
                }, 200);
            } else if(res.error === 'You do not have permission to make this change') {
                toast.error("You do not have permission to make this change.");
            } else {
                toast.error("An Issue occured, please retry");
            }
        }).catch((err) => {
            toast.error("Network Error: " + err);
        });
    };



    const handleDeleteEvent = () => {
        if (events.length === 0) return;
        const confirmed = window.confirm("Are you sure you want to permanently delete this event and all its volunteers? This cannot be undone.");
        if (!confirmed) return;

        resources.admin_delete(events[0]['id']).then(res => {
            if (res.error.length < 1) {
                toast.success("Event deleted successfully");
                window.location.href = window.location.origin + '/manageevents';
            } else if (res.error === 'You do not have permission to make this change') {
                toast.error("You do not have permission to make this change.");
            } else {
                toast.error("Delete failed: ");
            }
        }).catch((err) => {
            toast.error("Network Error: " + err);
        });
    };

    const handleToggleTeamMembersOnly = () => {
        if (events.length === 0) return;
        const current = events[0]['team_members_only'] === 'True';
        const newValue = !current;
        let formData = {};
        formData['user_email'] = loggedInUser['email'];
        formData['id'] = events[0]['id'];
        formData['team_members_only'] = newValue;

        resources.admin_put(formData).then(res => {
            if (res.error.length < 1) {
                toast.success("Team members only setting updated to: " + (newValue ? 'Yes' : 'No'));
                setTimeout(() => {
                    window.location.href = window.location.origin + '/eventdetailsadmin?id=' + events[0]['id'];
                }, 200);
            } else if (res.error === 'You do not have permission to make this change') {
                toast.error("You do not have permission to make this change.");
            } else {
                toast.error("Update failed: " + res.error);
            }
        }).catch((err) => {
            toast.error("Network Error: " + err);
        });
    };

    const loadEvent = (eventId) => {
        return resources.get_adminSingleEvent(eventId)
    }

    const loadEventVolunteers = (eventId) => {
        return resources.get_adminVolunteers(eventId)
    }

    const loadUsers = () => {
        let userResources = new UserResources()
        return userResources.get_admin()
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        //const searchParamss = queryString.parse(location.search)
        
         const eventId = searchParams.get('id');
         setEventId(eventId)

        loadEvent(eventId).then(response => {
            setEvents(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

        loadEventVolunteers(eventId).then(response => {
            setEventVolunteers(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

        loadUsers().then(response => {
            setUsers(response['body']);
        }).catch((err) => {
            toast.error("Network error: " + err)
        });

        rotaRoleResources.getRoles().then(response => {
            setRotaRoles(response['body'] || [])
        }).catch(() => {});

    }, []);

    useEffect(() => {
        if (events.length > 0) {
            checkRotaPublishedStatus();
        }
    }, [events]);

    let members = []  //dropdown values is the user information
    users.map((user, index) => (
        members.push({value: user, label: user['firstname'] + " " + user['lastname'] })
    ))
    return(
        <Fragment>
            <Topbar/>
            {isGenerating && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0,49,101,0.85)',
                    zIndex: 9999,
                    display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center',
                    color: '#fff'
                }}>
                    <div style={{
                        width: '60px', height: '60px',
                        border: '6px solid rgba(255,168,0,0.3)',
                        borderTop: '6px solid #ffa800',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        marginBottom: '20px'
                    }} />
                    <h3 style={{margin: 0, color: '#ffa800'}}>Generating Rota...</h3>
                    <p style={{marginTop: '8px', color: '#ccc', fontSize: '14px'}}>This may take a few seconds, please wait.</p>
                    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                </div>
            )}
             <div className="hero-area">
             <div className="page-banner parallax" style={{backgroundColor:"#003165"}}>
                    <div className="container">                    
                        <div className="page-banner-text">
                            <h1 style={{color:"#ffa800"}} className="block-title"><strong>Event Details</strong></h1>                                                      
                        </div>
                    </div>
                </div>
            </div>

            {/* <!--Main Content> */}
            <div id="main-container">
                <div className="content">                    
                    <div className="container">
                    <div className="row">   
                    <div className="grid-item event-grid-item format-standard">
                        
                        {
                            // ToDO: another component for event details for only team members
                            events.length > 0 && ((events[0]['team_members_only'] === 'True' && isLoggedIn) || events[0]['team_members_only'] === 'False') ?
                        
                        <div className="grid-item-inner"><a href={events && events.length > 0 && events[0]['image']} className="media-box" target="_blank">  
                            {events && events.length > 0 && (
                                <img src={events[0]['image']} style={{width: "100%", maxWidth: "800px", height: "clamp(180px, 40vw, 420px)", objectFit: "cover", borderRadius: "8px"}} alt=""/>
                                )}   
                            </a>

                            <div className="spacer-50"></div><div className="spacer-50"></div>
                            <div className="spacer-50"></div><div className="spacer-50"></div>
                            <div className="spacer-50"></div><div className="spacer-50"></div>

                            
                            {events.map((event, idx) => (
                                <div className="grid-item-content" key = {idx} >
                                <span style={{backgroundColor:"#ffa800"}} className="event-date">
                                    <span className="date">{moment(event['event_date']).format('DD')}</span>
                                    <span className="month">{moment(event['event_date']).format('MMM')}</span>  
                                    <span className="year">{moment(event['event_date']).format('YYYY')}</span>
                                </span>
                                <span className="meta-data">{moment(event['start_time']).format('dddd, HH:mm')}</span>
                                <h2 className="post-title"><p style={{color:"#003165"}}>{event['name']}</p></h2>                                
                                <div className="spacer-20"></div>
                                <ul className="list-group">                                    
                                    <li className="list-group-item">{event['event_venue']}<span className="badge">Location</span></li>
                                    <li className="list-group-item">{event['number_attendees']}<span className="badge">Attendees</span></li>
                                    <li className="list-group-item">{event['event_requirements']}<span className="badge">Event Requirements</span></li>                                    
                                    { isLoggedIn ? <li className="list-group-item">{event['contact_name'] + "  " + event['phone'] }<span className="badge">Event Contact</span></li>:<></>}
                                    <li className="list-group-item">{event['other_detail']}<span className="badge">Other details</span></li>
                                    
                                </ul>
                                <div className="spacer-20"></div>
                                 {
                                    isLoggedIn && loggedInUser['role.name'] === 'admin' ?
                                    <div style={{marginTop: '20px', padding: '16px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e0e0e0'}}>
                                        <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                                            <span style={{color: '#003165', fontWeight: 'bold', fontSize: 'clamp(13px, 3.8vw, 15px)'}}>Media Setup Time:</span>
                                            <span style={{color: '#ffa800', fontWeight: 'bold', fontSize: 'clamp(13px, 3.8vw, 15px)'}}>{moment(event['media_setup_time']).format('dddd, HH:mm')}</span>
                                        </div>
                                        {loggedInUser['role.name'] === 'admin' ?
                                        <div style={{marginTop: '10px', display: 'flex', alignItems: 'center', gap: '10px'}}>
                                            <DateTime
                                                value={mediaStartTime}
                                                onChange={(value) => handleTimeChange(value)}
                                                dateFormat={false}
                                                timeFormat="HH:mm"
                                            />
                                            <button style={{backgroundColor: '#007bff', color: '#fff', padding: '6px 14px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'}} onClick={handleUpdateMediaSetupTime}>Change Time</button>
                                        </div>
                                         :  <></>
                                    }
                                    </div>

                                    :<></>

                                 }

                            </div>

                            ))}

                        </div>:<><h1 style={{color:"#ffa800"}} className="block-title"><strong>No Access to this Event Details</strong></h1>  </>
                    }
                    </div>

                    {
                        (loggedInUser !== null && loggedInUser['role.name'] === 'admin' ) ?
                        events.map((ev, idx) => (
                            ev['enabled'] === '0' ?
                        <div style={{marginTop: '20px', display: 'flex', gap: '10px'}}>
                            <button style={{ backgroundColor: "#8ccd80", color: "#003165", padding: '8px 18px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'}} onClick={() => handleApproveEventButtonClick(ev)} >Approve Event</button>
                            <button style={{backgroundColor: "#d80000", color: "#fff", padding: '8px 18px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'}} onClick={() => handleRefuseEventButtonClick(ev)} >Refuse Event</button>
                        </div> : <></>
                        ))
                        :<></>
                    }

                    <div className="spacer-40"></div>

                    {
                        isLoggedIn ?
                        <div style={{backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #e0e0e0', padding: '20px', marginBottom: '20px'}}>
                            <h3 style={{color: '#003165', margin: '0 0 16px 0'}}>Media Volunteers</h3>
                            {eventVolunteers.length > 0 ?
                            <TableContainer component={Paper} style={{boxShadow: 'none', border: '1px solid #e0e0e0', borderRadius: '8px'}}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow style={{backgroundColor: '#003165'}}>
                                            <TableCell style={{color: '#fff', fontWeight: 'bold'}}>First Name</TableCell>
                                            <TableCell style={{color: '#fff', fontWeight: 'bold'}}>Last Name</TableCell>
                                            <TableCell style={{color: '#fff', fontWeight: 'bold'}}>Availability Info</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                    {eventVolunteers.map((volunteer, idx) => (
                                        <TableRow key={idx} style={{backgroundColor: idx % 2 === 0 ? '#fff' : '#f8f9fa'}}>
                                            <TableCell>{volunteer['user.firstname']}</TableCell>
                                            <TableCell>{volunteer['user.lastname']}</TableCell>
                                            <TableCell>{volunteer['availabilty_info'] || '-'}</TableCell>
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            :
                            <p style={{color: '#999', fontStyle: 'italic', margin: 0}}>No volunteers signed up yet.</p>
                            }
                        </div>
                        : <></>
                    }

                    {
                        isLoggedIn && loggedInUser['role.name'] === 'admin' ?
                        <div style={{backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #e0e0e0', padding: '20px', marginBottom: '20px'}}>
                            <h3 style={{color: '#003165', margin: '0 0 8px 0'}}>Manage Volunteers</h3>
                            <p style={{color: '#666', margin: '0 0 16px 0', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>To Remove a Volunteer, select the volunteer from the dropdown and click "Remove".</p>
                            <div style={{display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'flex-end'}}>
                                <div style={{flex: '1 1 200px', minWidth: '200px'}}>
                                    <Select
                                        name='members'
                                        id="members"
                                        classNamePrefix='select-css-tag'
                                        onChange={handleDropdownChange}
                                        options={members}
                                        placeholder="Select Team Member"
                                    />
                                </div>
                                <div style={{flex: '1 1 200px', minWidth: '200px'}}>
                                    <input
                                        type="text"
                                        value={availabiltyInfo}
                                        onChange={handleAvailabilityInputChange}
                                        placeholder="Additional availability info"
                                        style={{width: '100%', padding: '8px 10px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                    />
                                </div>
                                <div style={{display: 'flex', gap: '8px'}}>
                                    <button
                                        onClick={handleAddVolunteerButtonClick}
                                        style={{backgroundColor: '#8ccd80', color: '#003165', padding: '8px 18px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                    >Add</button>
                                    <button
                                        onClick={handleDeleteVolunteerButtonClick}
                                        style={{backgroundColor: '#d80000', color: '#fff', padding: '8px 18px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: 'clamp(13px, 3.5vw, 14px)'}}
                                    >Remove</button>
                                </div>
                            </div>
                        </div>
                        : <></>
                    }

                    {
                        isLoggedIn && loggedInUser !== null && loggedInUser['role.name'] === 'admin' ?
                        <div style={{backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #e0e0e0', padding: '20px', marginBottom: '20px'}}>
                            <h3 style={{color: '#003165', margin: '0 0 12px 0'}}>Event Status</h3>
                            <p style={{color: '#666', margin: '0 0 16px 0', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>Closing an event will prevent further volunteer signups.</p>
                            <div style={{display: 'flex', alignItems: 'center', gap: '16px', flexWrap: 'wrap'}}>
                                <span style={{color: '#003165', fontSize: 'clamp(13px, 3.8vw, 15px)'}}>
                                    Current Status: <strong style={{color: events.length > 0 && events[0]['event_closed'] === 'True' ? '#d80000' : '#8ccd80'}}>{events.length > 0 && events[0]['event_closed'] === 'True' ? 'Closed' : 'Open'}</strong>
                                </span>
                                <button
                                    onClick={handleCloseEventButtonClick}
                                    disabled={events.length > 0 && events[0]['event_closed'] === 'True'}
                                    style={{
                                        backgroundColor: events.length > 0 && events[0]['event_closed'] === 'True' ? '#ccc' : '#d80000',
                                        color: '#fff',
                                        padding: '8px 18px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: events.length > 0 && events[0]['event_closed'] === 'True' ? 'not-allowed' : 'pointer',
                                        fontWeight: 'bold'
                                    }}
                                >Close Event</button>
                                <button
                                    onClick={handleOpenEventButtonClick}
                                    disabled={events.length > 0 && events[0]['event_closed'] === 'False'}
                                    style={{
                                        backgroundColor: events.length > 0 && events[0]['event_closed'] === 'False' ? '#ccc' : '#8ccd80',
                                        color: events.length > 0 && events[0]['event_closed'] === 'False' ? '#999' : '#003165',
                                        padding: '8px 18px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: events.length > 0 && events[0]['event_closed'] === 'False' ? 'not-allowed' : 'pointer',
                                        fontWeight: 'bold'
                                    }}
                                >Open Event</button>
                            </div>
                        </div>
                        : <></>
                    }

                    {
                        isLoggedIn && loggedInUser !== null && loggedInUser['role.name'] === 'admin' ?
                        <div style={{backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #e0e0e0', padding: '20px', marginBottom: '20px'}}>
                            <h3 style={{color: '#003165', margin: '0 0 8px 0'}}>Edit Event Date &amp; Times</h3>
                            <p style={{color: '#666', margin: '0 0 16px 0', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>
                                Current: <strong>{events.length > 0 ? moment(events[0]['event_date']).format('DD MMM YYYY') : ''}</strong>
                                {events.length > 0 ? `, ${moment(events[0]['start_time']).format('HH:mm')} – ${moment(events[0]['end_time']).format('HH:mm')}` : ''}
                            </p>
                            <div style={{display: 'flex', flexWrap: 'wrap', gap: '16px', alignItems: 'flex-end'}}>
                                <div>
                                    <label style={{display: 'block', color: '#003165', fontWeight: 'bold', marginBottom: '4px', fontSize: '13px'}}>Event Date</label>
                                    <input
                                        type="date"
                                        value={editEventDate}
                                        onChange={(e) => setEditEventDate(e.target.value)}
                                        min={moment().format('YYYY-MM-DD')}
                                        style={{padding: '6px 10px', border: '1px solid #ccc', borderRadius: '4px', fontSize: '14px'}}
                                    />
                                </div>
                                <div>
                                    <label style={{display: 'block', color: '#003165', fontWeight: 'bold', marginBottom: '4px', fontSize: '13px'}}>Start Time</label>
                                    <DateTime
                                        value={editStartTime}
                                        onChange={(value) => setEditStartTime(value)}
                                        dateFormat={false}
                                        timeFormat="HH:mm"
                                    />
                                </div>
                                <div>
                                    <label style={{display: 'block', color: '#003165', fontWeight: 'bold', marginBottom: '4px', fontSize: '13px'}}>End Time</label>
                                    <DateTime
                                        value={editEndTime}
                                        onChange={(value) => setEditEndTime(value)}
                                        dateFormat={false}
                                        timeFormat="HH:mm"
                                    />
                                </div>
                                <button
                                    onClick={handleUpdateEventDateTime}
                                    style={{backgroundColor: '#007bff', color: '#fff', padding: '6px 14px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'}}
                                >Update</button>
                            </div>
                        </div>
                        : <></>
                    }

                    {
                        isLoggedIn && loggedInUser !== null && loggedInUser['role.name'] === 'admin' ?
                        <div style={{backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #e0e0e0', padding: '20px', marginBottom: '20px'}}>
                            <h3 style={{color: '#003165', margin: '0 0 8px 0'}}>Team Members Only</h3>
                            <p style={{color: '#666', margin: '0 0 16px 0', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>
                                Current: <strong style={{color: events.length > 0 && events[0]['team_members_only'] === 'True' ? '#003165' : '#8ccd80'}}>
                                    {events.length > 0 && events[0]['team_members_only'] === 'True' ? 'Yes — Team members only' : 'No — Open to all'}
                                </strong>
                            </p>
                            <button
                                onClick={handleToggleTeamMembersOnly}
                                style={{
                                    backgroundColor: events.length > 0 && events[0]['team_members_only'] === 'True' ? '#8ccd80' : '#003165',
                                    color: events.length > 0 && events[0]['team_members_only'] === 'True' ? '#003165' : '#fff',
                                    padding: '8px 18px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontWeight: 'bold'
                                }}
                            >
                                {events.length > 0 && events[0]['team_members_only'] === 'True' ? 'Make Open to All' : 'Restrict to Team Members'}
                            </button>
                        </div>
                        : <></>
                    }

                    {
                        isLoggedIn && loggedInUser !== null && loggedInUser['role.name'] === 'admin' ?
                        <div style={{backgroundColor: '#fff', borderRadius: '10px', border: '1px solid #e0e0e0', padding: '20px', marginBottom: '20px'}}>
                            <h3 style={{color: '#003165', margin: '0 0 16px 0'}}>Generate Rota</h3>

                            {/* Requested Roles */}
                            <div style={{marginBottom: '16px'}}>
                                <label style={{color: '#003165', fontWeight: 'bold', display: 'block', marginBottom: '6px'}}>Requested Roles (Optional)</label>
                                <div style={{backgroundColor: '#fff3cd', border: '1px solid #ffc107', padding: '8px 12px', borderRadius: '4px', marginBottom: '10px', color: '#856404', fontSize: '13px'}}>
                                    <strong>Note:</strong> If you request roles, only those roles will be used in the rota creation.
                                </div>
                                <Select
                                    value={selectedRoles}
                                    onChange={(opts) => setSelectedRoles(opts || [])}
                                    options={rotaRoles.map(r => ({ value: r.id, label: r.name }))}
                                    placeholder="Select Roles (Optional)"
                                    isMulti
                                />
                            </div>

                            {/* Role Mapping — only shown when roles are selected */}
                            {selectedRoles && selectedRoles.length > 0 && (
                                <div style={{marginBottom: '16px'}}>
                                    <label style={{color: '#003165', fontWeight: 'bold', display: 'block', marginBottom: '8px'}}>Role Mapping * (At least one required)</label>
                                    <TableContainer component={Paper}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell><strong>Core Role</strong></TableCell>
                                                    <TableCell><strong>Custom Role</strong></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>Close Up Camera</TableCell>
                                                    <TableCell>
                                                        <Select
                                                            value={closeUpMapping}
                                                            onChange={(opts) => setCloseUpMapping(opts || [])}
                                                            options={rotaRoles.filter(r => !r.is_core_role).map(r => ({ value: r.id, label: r.name }))}
                                                            placeholder="Select custom roles"
                                                            isMulti
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell>Roaming Camera</TableCell>
                                                    <TableCell>
                                                        <Select
                                                            value={roamingMapping}
                                                            onChange={(opts) => setRoamingMapping(opts || [])}
                                                            options={rotaRoles.filter(r => !r.is_core_role).map(r => ({ value: r.id, label: r.name }))}
                                                            placeholder="Select custom roles"
                                                            isMulti
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            )}

                            <button
                                onClick={handleRotaGeneration}
                                disabled={isRotaPublished}
                                style={{
                                    backgroundColor: isRotaPublished ? '#ccc' : '#007bff',
                                    color: '#fff',
                                    padding: '8px 18px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: isRotaPublished ? 'not-allowed' : 'pointer',
                                    fontWeight: 'bold'
                                }}
                            >
                                {isRotaPublished ? 'Rota Published' : 'Generate Rota'}
                            </button>
                        </div>
                        : <></>
                    }

                    {
                        isLoggedIn && loggedInUser !== null && loggedInUser['role.name'] === 'admin' ?
                        <div style={{backgroundColor: '#fff3f3', borderRadius: '10px', border: '1px solid #f5c6cb', padding: '20px', marginBottom: '20px'}}>
                            <h3 style={{color: '#d80000', margin: '0 0 8px 0'}}>Danger Zone</h3>
                            <p style={{color: '#666', margin: '0 0 16px 0', fontSize: 'clamp(13px, 3.5vw, 14px)'}}>Permanently deletes this event and all associated volunteers. This cannot be undone.</p>
                            <button
                                onClick={handleDeleteEvent}
                                style={{backgroundColor: '#d80000', color: '#fff', padding: '8px 18px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold'}}
                            >Delete Event</button>
                        </div>
                        : <></>
                    }

                    <div className="spacer-40"></div>
                    </div>
                    </div>
                </div>
            </div>
            <Footer/>

        </Fragment>
    )
}

const mapStateToProps = (state) => {
    return{
       isLoggedIn: state.authReducer.isLoggedIn,
       loggedInUser: state.authReducer.user
    };
    
};

const mapDispatchToProps = {
    logout
};

export default connect(mapStateToProps, mapDispatchToProps)(EventDetailsAdmin);